import styled, { css } from 'styled-components'

export const PLAN_SELECTOR_BREAKPOINT = '1200px'

export const Container = styled.div<{ numOfAvailablePlans?: number }>`
  display: grid;
  grid-template-columns: ${(props): string =>
    `${props.numOfAvailablePlans}fr 1fr`};
  align-items: stretch;
  border-radius: var(--border-radius-md);
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;

  @media (max-width: ${PLAN_SELECTOR_BREAKPOINT}) {
    grid-template-columns: 1fr;
    overflow-y: scroll;
    width: 95vw;
    height: 800px;
    max-height: 95vh;
    background-color: var(--color-bg-xsubtle);
  }
`

export const LoadingContainer = styled(Container)`
  width: 600px;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 24px 0px 24px;
  justify-content: flex-start;
  box-sizing: border-box;
  background-image: url('https://buffer-ui.s3.amazonaws.com/Plan+Screen+-+Background.png');
  background-position-x: 85%;
  background-repeat: no-repeat;
  background-size: 400px;
  background-position-y: 0px;

  @media (max-width: ${PLAN_SELECTOR_BREAKPOINT}) {
    width: 95vw;
    background-size: 100%;
  }
`

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background-color: var(--color-bg-xsubtle);
  box-shadow: inset 1px 0px 0px var(--color-border-subtle);

  h2 {
    margin-top: 0;
    margin-bottom: 19px;
  }

  @media (max-width: 1200px) {
    max-width: 360px;
  }
`

export const PlanSelectorHeader = styled.header`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  @media (max-width: ${PLAN_SELECTOR_BREAKPOINT}) {
    max-width: 360px;
    flex-direction: column;
    align-items: flex-start;

    h2 {
      margin: 0;
    }
  }
`

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;

  p {
    color: var(--color-text-neutral);
    font-family: var(--font-family-body);
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-body);
    margin-left: 8px;
  }
`

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
`

export const AbsoluteSavings = styled.span`
  font-family: var(--font-family-body);
  font-size: var(--font-size-body);
  font-style: normal;
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-body);
  letter-spacing: 0px;
  color: var(--color-text-brand);
  text-align: right;
  width: 120px;
  margin-left: 5px;
`

export const ButtonContainer = styled.div`
  border-bottom-right-radius: var(--border-radius-md);
  margin: 0 0 20px 20px;
  box-sizing: border-box;
  width: 235px;
`

export const NoticeWrapper = styled.div`
  > div > div {
    width: 100%;
  }
`

// SELECTION SCREEN STYLES

interface IWrapper {
  isSelectedPlan: boolean
  isMobileBillingUser: boolean
}

export const Wrapper = styled.div<IWrapper>`
  border: ${(props): string =>
    props.isSelectedPlan
      ? '1.5px solid transparent'
      : `1.5px solid var(--color-border-subtle)`};
  box-shadow: ${(props): string =>
    props.isSelectedPlan
      ? `0px 0px 0px 1.5px var(--color-border-brand), 0px 4px 8px rgba(0, 0, 0, 0.04)`
      : `0px 4px 8px rgba(0, 0, 0, 0.04)`};
  border-radius: var(--border-radius-sm);
  height: 490px;
  position: relative;
  padding: 28px 18px;
  flex: 1 1 0px;
  margin-right: 12px;
  box-sizing: border-box;
  background: var(--color-bg-neutral);
  cursor: ${(props): string =>
    props.isMobileBillingUser ? 'auto' : 'pointer'};
  width: 260px;

  transition-property: border-color;
  transition-duration: 250ms;
  transition-timing-function: ease-in-out;

  p {
    font-weight: 500;
    margin: 0;
  }

  div + p {
    max-width: 200px;
  }

  h3 {
    margin: 0;
  }

  #new-tag {
    margin-left: 4px;
  }

  ${(props): any =>
    !props.isMobileBillingUser &&
    css<IWrapper>`
      &:focus,
      &:hover {
        border: ${(props): string =>
          props.isSelectedPlan
            ? '1.5px solid transparent'
            : `1.5px solid var(--color-border-brand)`};
        outline: none;
      }
    `}

  @media (max-width: ${PLAN_SELECTOR_BREAKPOINT}) {
    width: 230px;
    height: 550px;
  }
`

export const CardContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 25px;
  margin-top: 10px;
  box-sizing: border-box;

  div:last-child {
    margin-right: 0;
  }

  @media (max-width: ${PLAN_SELECTOR_BREAKPOINT}) {
    overflow-x: scroll;
    margin-bottom: 5px;
    padding: 6px 4px;
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  margin-bottom: 16px;

  h3 {
    font-size: 16px;
    line-height: 26px;
  }
`

interface ICheck {
  isSelectedPlan: boolean
}
export const Check = styled.div<ICheck>`
  margin-left: auto;
  border: 1.5px solid
    ${({ isSelectedPlan }): string =>
      isSelectedPlan
        ? 'var(--color-border-brand)'
        : 'var(--color-border-subtle)'};
  background: ${({ isSelectedPlan }): string =>
    isSelectedPlan ? 'var(--color-bg-brand)' : 'var(--color-bg-neutral)'};
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  border-radius: var(--border-radius-full);
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: var(--color-text-inverted);
    width: 18px;
    height: 18px;

    .vrLight [aria-label='checked'] &,
    .vrDark [aria-label='checked'] & {
      color: var(--color-text-brand-xstrong);
      width: 16px;
      height: 16px;
    }
  }
`

export const CardFooter = styled.div`
  label {
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-body-sm);
    white-space: pre-wrap;
  }
`

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  height: 31%;
`

export const CurrentLabel = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
  width: 64px;
  height: 25px;
  background: var(--color-bg-subtle);
  border-radius: var(--border-radius-sm);

  font-family: var(--font-family-body);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-body-sm);
  line-height: 140%;
  letter-spacing: 0.4px;
  color: var(--color-text-neutral);
  text-transform: uppercase;
  margin-left: 12px;
  box-sizing: border-box;
`

export const Recommended = styled(CurrentLabel)`
  background: var(--color-bg-brand);
  color: var(--color-text-inverted);
  width: 110px;
  z-index: 1;
  position: absolute;
  top: -12px;
  left: 0;
  right: 0;
  margin: auto;
`

interface IRadioButton {
  selectedPlan: boolean
}

export const RadioButton = styled.div<IRadioButton>`
  position: absolute;
  top: 21px;
  right: 21px;

  border-radius: var(--border-radius-full);
  width: 24px;
  height: 24px;
  background-color: ${(props): string =>
    props.selectedPlan ? `var(--color-bg-brand)` : 'transparent'};

  border: ${(props): string =>
    props.selectedPlan
      ? `2px solid var(--color-border-brand)`
      : '2px solid var(--color-border-subtle)'};
  transition: 0.2s all linear;
  margin-right: 5px;

  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: content-box;

  svg {
    fill: var(--color-text-inverted);
  }
`

export const Price = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: -4px;

  sup {
    font-family: var(--font-family-body);
  }

  sup:first-child {
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-body-lg);
    line-height: 100%;
  }

  sup::last-child {
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-body);
    line-height: 140%;
  }

  p {
    color: var(--color-text-neutral);
    margin-left: 2px;
    margin-right: 2px;
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-heading-xl);
  }
`

export const TotalPrice = styled(Price)`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  position: initial;

  p {
    margin: 0 2px;
    font-size: var(--font-size-heading-lg);
    line-height: var(--line-height-heading);
  }
`

export const BenefitList = styled.div`
  h3 {
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    line-height: var(--line-height-body);
    margin-bottom: 4px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    p {
      color: var(--color-text-subtle);
    }
  }

  &::before {
    content: '';
    border-top: 1px solid var(--color-border-subtle);
    width: 207px;
    display: block;
    margin-bottom: 8px;
    margin-top: 16px;
  }
`

export const Benefit = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 2px;

  p {
    font-size: var(--font-size-body-sm);
    color: var(--color-text-subtle);
  }

  svg {
    fill: var(--color-text-brand);
    margin-right: 8px;
  }
`

export const DowngradeMessage = styled.li`
  display: flex;
  max-width: 610px;
  font-family: var(--font-family-body);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-body);
  color: var(--color-text-brand);

  svg {
    fill: var(--color-text-brand);
    height: 22px;
    width: 22px;
    margin-top: -4px;
    margin-right: 5px;
  }
`
